import { useEffect, useRef, useContext, FC } from 'react'
import get from 'lodash/get'
import jsLogger from 'js-logger'
// import RVideo from 'shared/components/recorder/Rvideo'
import RecorderControls from 'shared/components/recorder/RecorderControls'
import RecorderVideo from 'shared/components/recorder/RecorderVideo'
import MicWarning from 'shared/components/MicWarning'
import StreamContext from 'shared/contexts/StreamContext'
import SessionVideoRecorderContext from 'shared/contexts/SessionVideoRecorderContext'

type Props = {
  // handleChunk?: (videoBlob: Blob, mimeType: string, role: 'user') => void
  onError?: (v: string) => void
  // Whether in-app mic controls are available (control panel shown). Drives
  // how the "we can't hear you" warning is surfaced.
  canConfigureMic?: boolean
}

const VideoRecorder: FC<Props> = ({ onError, canConfigureMic = false }) => {
  const { stream, controls, changeControls } = useContext(StreamContext)
  // const videoRecorderRef = useRef<RVideo>()
  const cameraVideoRef = useRef<HTMLVideoElement>(null)
  const { setUserVideoElement } = useContext(SessionVideoRecorderContext)

  useEffect(() => {
    if (
      stream &&
      cameraVideoRef.current &&
      cameraVideoRef.current.srcObject !== stream
    ) {
      try {
        if (cameraVideoRef.current) {
          cameraVideoRef.current.srcObject = stream
          setUserVideoElement(cameraVideoRef.current)
        }
        // if (handleChunk) {
        //   videoRecorderRef.current?.stop()
        //   videoRecorderRef.current = new RVideo(
        //     stream,
        //     () => jsLogger.log('video recording is stopped'),
        //     onNewChunk
        //   )
        // }
      } catch (e) {
        jsLogger.error('ERROR: Recorder | turnOnCamera failed', {
          msg: get(e, 'message')
        })
        if (onError) onError(get(e, 'message', ''))
      }
    } else if (stream === null) {
      if (cameraVideoRef.current) {
        cameraVideoRef.current.srcObject = null
        setUserVideoElement(cameraVideoRef.current)
      }
    }
  }, [stream])

  const handleMicOrCameraClick = (type: 'mic' | 'camera') => {
    const newControls = { ...controls, [type]: !controls[type] }
    jsLogger.log(`RECORDER: handleMicOrCameraClick: ${type}`, {
      newControls
    })
    changeControls(newControls)
  }

  // const onNewChunk = (blob: Blob) => {
  //   if (videoRecorderRef.current) {
  //     const mimeType = videoRecorderRef.current.mimeType
  //     handleChunk && handleChunk(blob, mimeType || '', 'user')
  //   } else {
  //     jsLogger.warn('onNewChunk user, videoRecorderRef is empty')
  //   }
  // }

  const renderControls = () => {
    return (
      <RecorderControls
        controls={controls}
        handleMicOrCameraClick={handleMicOrCameraClick}
      />
    )
  }

  const renderCameraView = () => {
    return (
      <div key='camera' className='w-full h-full rounded-md'>
        {renderControls()}
        <MicWarning canConfigure={canConfigureMic} />
        <RecorderVideo controls={controls} cameraVideoRef={cameraVideoRef} />
      </div>
    )
  }

  return (
    <div
      className={
        'absolute top-0 left-0 bottom-0 right-0 w-full h-full rounded-md border'
      }
    >
      {renderCameraView()}
      {/* {!isActive && (
        <div className='absolute top-0 left-0 bottom-0 right-0 w-full h-full rounded-md shadow-lg bg-blackAlpha-400' />
      )} */}
    </div>
  )
}

export default VideoRecorder
